<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="上传发票" prop="fileInfos">
                <my-upload @filesChange="filesChange" :canEdit="!editMode" :isLimitMaxSiz="true" :oldList="form.fileInfos"></my-upload>
              </el-form-item>
              <!-- <UploadFileList :fileList="form.fileInfos" btnShowType="always" :showLabel="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList> -->
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="billNo" label="发票号码" v-if="getIsView()">
                <el-input :disabled="!editMode" :controls="false" placeholder="可输入多个发票号码,用逗号隔开" style="width: 100%" v-model="form.billNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票号码:{{ form.billNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="billCode" label="发票代码" v-if="getIsView()">
                <el-input :disabled="!editMode" :controls="false" style="width: 100%" v-model="form.billCode"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票代码:{{ form.billCode }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="checkCode" label="校验码" v-if="getIsView()">
                <el-input :disabled="!editMode" :controls="false" style="width: 100%" v-model="form.checkCode"></el-input>
              </el-form-item>
              <span class="viewText" v-else>校验码:{{ form.checkCode }} </span>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <!-- <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择供应商" filterable :filter-method="getSuppliers" @change="supplierChange" style="width:100%">
                  <el-option key="0" label="请选择供应商" value></el-option>
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
                <SelectTable :disabled="!editMode" :columns="supplierColumns" :placeholder="'请选择供应商'" :innerName="form.supplierName" :dataList="STATIC_Suppliers" @filterMethod="getSuppliers" @change="supplierChange" />
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="invoiceAmount" label="发票金额(元)" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.invoiceAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发票金额(元):{{ form.invoiceAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="type" label="随货发票" v-if="getIsView()">
                <el-radio-group :disabled="!editMode" v-model="form.type">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>随货发票:{{ form.type == 0 ? '否' : '是' }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="invoiceForm" label="发票形式" v-if="getIsView()">
                <el-select v-model="form.invoiceForm" :disabled="!editMode" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in InvoiceFormOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>发票形式:{{ InvoiceFormOptions.find(item => item.id === form.invoiceForm)?.name }} </span>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="categorys" label="业务类型" v-if="getIsView()">
                <el-select v-model="selectValue" :disabled="!editMode" multiple placeholder="请选择" style="width:100%" @change="categoryChange">
                  <el-option v-for="item in StockCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>业务类型:{{ categorysNames }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="isRed" label="红冲发票" v-if="getIsView()">
                <el-radio-group v-model="form.isRed" :disabled="!editMode" @change="isRedChange">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>红冲发票:{{ form.isRed == 0 ? '否' : '是' }} </span>
            </el-col>
            <el-col :span="6" v-if="form.isRed =='1'" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oldBillCode" label=" 原发票号" v-if="getIsView()">
                <el-select v-model="form.oldBillCode" :disabled="!editMode" placeholder="请选择发票号码" filterable :filter-method="getInvoiceRegisters" @change="invoiceRegisterChange" style="width:100%">
                  <el-option key="0" label="请选择发票号码" value></el-option>
                  <el-option v-for="item in invoices" :key="item.id" :label="item.billNo" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>原发票号:{{ form.oldBillCode }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="发票日期" v-if="getIsView()">
                <el-date-picker v-model="form.date" :disabled="!editMode" size="small" type="date" format="yyyy-MM-dd" style="width:100%" value-format="yyyy-MM-dd" placeholder="放款期限"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>发票日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }} </span>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" v-if="form.registerWay==0&&getIsView()" label="登记人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-if="form.registerWay==0&&!getIsView()">登记人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="登记时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.sourceCreatedTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>登记时间:{{  parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="state" label="状态" v-if="getIsView()">
                <!-- <el-input disabled v-model="form.stateName"></el-input> -->
                <el-select disabled v-model="form.state" style="width: 100%">
                  <el-option v-for="item in InvoiceRegisterOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>状态:{{ InvoiceRegisterOptions.find(item => item.id === form.state)?.name }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="登记方式" prop="registerWay" v-if="getIsView()">
                <el-select disabled v-model="form.registerWay" style="width: 100%">
                  <el-option v-for="item in RegisterWayOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>登记方式:{{ RegisterWayOptions.find(item => item.id === form.registerWay)?.name }} </span>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="18" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="remark" label="备注" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="匹配金额合计(元)" v-if="getIsView()">
                <el-input disabled v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>匹配金额合计(元):{{ form.totalAmount }} </span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">发票明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn primary" size="small" v-preventReClick @click="handleAddChildForm">添加</el-button>
            <template>
              <el-radio-group v-model="form.selectType" :disabled="!editMode" @change="restDetails">
                <el-radio :label="0">按整单选择</el-radio>
                <el-radio :label="1">按明细选择</el-radio>
              </el-radio-group>
              <!-- <el-radio v-model="form.selectType" :label="0" @change="restDetails">按整单选择</el-radio>
              <el-radio v-model="form.selectType" :label="1" @change="restDetails">按明细选择</el-radio> -->
            </template>
            <span style="color:red;background-color: #f1dfbf;"><i class="el-icon-warning"></i>&nbsp;提示:1、两种选择方式二选一，切换后已选数据将被清空。</span>
            <!-- <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button> -->
          </div>
          <div v-else style="margin-top: 20px">
          </div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <!-- <el-table-column type="selection" width="55" align="center" fixed></el-table-column> -->
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip label="配送单号/配送日期" align="center" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.drmDistributionNo }} <br>{{ parseTime(new Date(scope.row.drmDistributionDate), "{y}-{m}-{d}")}}
              </template>
            </el-table-column>
            <el-table-column v-if="true" show-overflow-tooltip label="入库单号/入库日期" align="center" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.purchaseInStockNo }} <br>{{ parseTime(new Date(scope.row.purchaseInStockDate), "{y}-{m}-{d}")}}
              </template>
            </el-table-column>
            <!-- <el-table-column show-overflow-tooltip label="入库单号/入库日期" align="center" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.purchaseInStockNo }}
                <br>{{ parseTime(new Date(scope.row.purchaseInStockDate), "{y}-{m}-{d}")}}
              </template>
            </el-table-column> -->
            <el-table-column show-overflow-tooltip prop="purchaseInStockWarehouseName" label="入库仓库" />
            <el-table-column v-if="form.selectType == 1" prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip label="产品名称/注册证号" align="center" min-width="170" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.productName }}<br> {{ scope.row.registCertNo }}
              </template>
            </el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip prop="specName" label="规格型号" />
            <el-table-column v-if="form.selectType == 1" prop="manufacturerName" label="生产厂家" width="120" />
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip label="批次号/有效期" align="center" min-width="170" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.batch }}<br> {{ parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")}}
              </template>
            </el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip prop="serialNo" label="序列号" />
            <el-table-column v-if="form.selectType == 1" prop="purchaseOrderNo" label="采购订单号" width="120" />
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip prop="newProductId" label="产品ID" />
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip prop="patientNo" width="120" label="住院号/门诊号" />
            <el-table-column v-if="form.selectType == 1" prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip label="单价/数量" align="center" min-width="120" fixed="right" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.inStockPrice }}<br>{{ scope.row.inStockNumber }}
              </template>
            </el-table-column>
            <el-table-column v-if="form.selectType == 1" show-overflow-tooltip label="入库金额/未匹配金额" align="center" min-width="160" fixed="right" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.inStockAmount }}<br>{{ scope.row.unRegisterAmount }}
              </template>
            </el-table-column>
            <el-table-column v-if="form.selectType == 1" prop="unRegisterNumber" label="未匹配数量" width="120" fixed="right" />
            <el-table-column v-if="form.selectType == 1" prop="number" label="本次匹配数量" width="120" fixed="right">
              <!-- <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入本次数量" type="number" @input='amountChange(scope.row)' v-model="scope.row.number"></el-input>
              </template> -->
            </el-table-column>
            <el-table-column v-if="form.selectType == 1" prop="amount" label="本次匹配金额" min-width="120" fixed="right" />
            <el-table-column v-if="form.selectType != 1" prop="amount" label="总金额（元）" min-width="120" fixed="right" />
            <el-table-column v-if="form.selectType != 1" prop="number" label="总数量" min-width="120" fixed="right" />
            <el-table-column v-if="form.selectType != 1" prop="remark" label="备注" min-width="150" fixed="right" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="submitShowBtn()" class="btn primary" type="primary" v-preventReClick @click="submit">验 证</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">提交审批</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="goBack">返 回</el-button>
    </div>
    <!-- <SelectDialog ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle" @close="closeSelectDialog" @returnData="getSelectDialogData" :filterOptions="filterOptions" :columOptions="columnOptions" :getDataFunction="GetUnInvoiceAccepInStock" :rowKey="'inStockDetailId'" :pageAuto="true"></SelectDialog> -->
    <SelectTabDialogByWholeOrder ref="selectDialogByWholeOrder" :show="showSelectDialogWholeOrder" :dialogTitle="selectDialogTitle" @close="closeSelectDialogWholeOrder" @returnData="getSelectDialogDataWholeOrder" :filterOptions="filterOptionsByWholeOrder" :columOptions="columnOptionsByWholeOrder" :getDataFunction="GetUnInvoiceNumberByWholeOrders" :rowKey="'inStockDetailId'" :returnInvoiceAmount="returnInvoiceAmount" :returnInvoiceCode="returnInvoiceCode"></SelectTabDialogByWholeOrder>

    
    <SelectTabDialog ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle" @close="closeSelectDialog" @returnData="getSelectDialogData" :filterOptions="filterOptions" :columOptions="columnOptions" :getDataFunction="GetUnInvoiceNumberByDetails" :rowKey="'inStockDetailId'" :returnInvoiceAmount="returnInvoiceAmount" :returnInvoiceCode="returnInvoiceCode"></SelectTabDialog>

  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetInvoiceRegisterById,
  SaveInvoiceRegister,
  RejectInvoiceRegister,
  GetUnInvoiceAccepInStock,
  GetInvoiceRegisters,
  GetUnInvoiceNumberByDetails,
  GetUnInvoiceNumberByWholeOrders,
  ValidatePeriodStockSupplier,
} from "@/api";
import { InvoiceFormOptions, StockCategoryOptions, RegisterWayOptions, InvoiceRegisterOptions, WhetherOptions } from "@/enum";
import ApproveInfo from "@/components/approve-info";
import SelectDialog from "@/components/select-dialog";
import SelectTabDialog from "@/components/select-tab-dialog";
import SelectTabDialogByWholeOrder from "@/components/select-tab-dialog-invoice";
import MyUpload from "@/components/my-upload";
import SelectTable from "@/components/select-table";

export default {
  name: "invoiceRegisterEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    ApproveInfo,
    SelectDialog,
    MyUpload,
    SelectTabDialog,
    SelectTable,
    SelectTabDialogByWholeOrder
  },
  data () {
    return {
      GetDataAction: GetInvoiceRegisterById,
      SaveDataAction: SaveInvoiceRegister,
      reject: RejectInvoiceRegister,
      form: {},

      // GetUnInvoiceAccepInStock: GetUnInvoiceAccepInStock,
      GetUnInvoiceNumberByDetails: GetUnInvoiceNumberByDetails,
      GetUnInvoiceNumberByWholeOrders: GetUnInvoiceNumberByWholeOrders,
      StockCategoryOptions: StockCategoryOptions,
      InvoiceFormOptions: InvoiceFormOptions,
      RegisterWayOptions: RegisterWayOptions,
      InvoiceRegisterOptions: InvoiceRegisterOptions,
      WhetherOptions: WhetherOptions,
      rules: {
        supplierName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
        billNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' },
          // { pattern: /^[0-9]*$/g, message: '校验码必须为数字值', trigger: 'blur' },
          // { validator: this.validateInvoiceRegisterNumber, trigger: 'blur' }
        ],
        invoiceAmount: [
          { required: true, message: '请输入发票金额(元)', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择发票日期', trigger: 'blur' }
        ],
        // invoiceForm: [
        //   { required: true, message: '请选择发票形式', trigger: 'blur' }
        // ],
        categorys: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择随货发票', trigger: 'blur' }
        ],
        isRed: [
          { required: true, message: '请选择供红冲发票', trigger: 'blur' }
        ],
        oldBillCode: [
          { required: true, message: '请选择原发票号', trigger: 'blur' }
        ],
        billCode: [
          // { type: 'number', message: '发票代码必须为数字值' },
          // { min: 12, max: 12, message: '必须为12位阿拉伯数字' }
          { pattern: /^[0-9]*$/g, message: '校验码必须为数字值', trigger: 'blur' },
          { validator: this.validateInvoiceRegisterNumber, trigger: 'blur' }
        ],
        checkCode: [
          // { type: 'number', message: '校验码必须为数字值' },
          // { min: 100000, max: 999999, message: '必须为6位阿拉伯数字' }
          { pattern: /^[0-9]*$/g, message: '校验码必须为数字值', trigger: 'blur' },
          { validator: this.validateInvoiceRegisterNumber, trigger: 'blur' }
        ],

      },

      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      invoices: [],
      editMode: false,
      showWorkFlowInfo: false,

      selectValue: [],
      showSelectDialog: false,
      showSelectDialogWholeOrder: false,
      selectDialogTitle: '选择待付款发票',
      filterOptions: [
        {
          name: "入库/退货单号",
          type: "input",
          code: "purchaseInStockNo",
        },
        {
          name: "批次号",
          type: "input",
          code: "batch",
        },
        {
          name: "配送单号",
          type: "input",
          code: "drmDistributionNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "超量标识",
          type: 'select',
          code: 'isChaoLiang',
          data: WhetherOptions
        },
        {
          name: "患者住院号或姓名",
          type: 'select',
          code: 'patientId',
          value:'parentId',
          filterMethod: this.getPatientDetailListNoDebounce1,
          data: [],
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
          defaultValue: [new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate()), new Date()]
        },
        {
          name: "是否红冲",
          type: "input",
          code: "isRed",
          hidden: true,
          defaultValue: 0
        },
        {
          name: "业务类型",
          type: 'select',
          code: 'categorys',
          multiple: true,
          hidden: true,
          defaultValue: [0, 1, 2]
        },
          {
          name: "合并打印流水号",
          type: "input",
          code: "mergePrintNo",
        },
      ],
      columnOptions: [
        {
          label: "单号/日期",
          key: "purchaseInStockNo",
          fomtter: this.child2fomtter,
          width: 140
        },
        {
          label: "是否超量",
          key: "isChaoLiang",
          fomtter: this.child7fomtter,
          width: 90
        },
        {
          label: "单价/数量",
          key: "productName",
          fomtter: this.child5fomtter
        },
        {
          label: "金额/未开票金额",
          key: "drmDistributionNo",
          fomtter: this.child6fomtter,
          width: 155
        },
        {
          label: "配送单号/配送日期",
          key: "purchaseInStockNo",
          fomtter: this.child1fomtter,
          width: 140
        },

        {
          label: "产品名称/注册证号",
          key: "purchaseInStockNo",
          fomtter: this.child3fomtter,
          width: 140
        },
        {
          label: '规格型号',
          key: 'specName'
        },
        {
          label: '批次号/有效期',
          key: 'batch',
          fomtter: this.child4fomtter,
          width: 120
        },
        {
          label: "序列号",
          key: "serialNo",
        },

        // {
        //   label: "32432",//未匹配数量
        //   key: "unRegisterNumber",// "unRegisterNumber",
        //   type: "input",
        //   width: 105
        // },
        {
          label: "本次匹配数量",//未匹配数量
          key: "thisUnRegisterNumber",// "unRegisterNumber",
          type: "input",
          width: 105
        },
        {
          label: "本次匹配金额",
          key: "thisAmount",//amount
          width: 105
        },
      ],
      columnOptionsByWholeOrder: [
        {
          label: "单号",
          key: "purchaseInStockNo",
          width: 135
        },
        {
          label: "是否超量",
          key: "isChaoLiang",
          fomtter: this.child7fomtter,
          width: 90
        },
        {
          label: "总金额（元）",
          key: "amount",
          width: 106
        },
        {
          label: "总数量",
          key: "number",
          width: 80
        },
        {
          label: "入库（退货）日期",
          key: "purchaseInStockDate",
          fomtter: this.fomtter,
          width: 180
        },

        {
          label: '仓库',
          key: 'purchaseInStockWarehouseName',
          width: 100
        },
        {
          label: '备注',
          key: 'remark',
          width: 200
        },
        
      ],
      filterOptionsByWholeOrder: [
        {
          name: "入库/退货单号",
          type: "input",
          code: "purchaseInStockNo",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
          defaultValue: [new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate()), new Date()]
        },
        {
          name: "是否红冲",
          type: "input",
          code: "isRed",
          hidden: true,
          defaultValue: 0
        },
        {
          name: "业务类型",
          type: 'select',
          code: 'categorys',
          multiple: true,
          hidden: true,
          defaultValue: [0, 1, 2]
        },
        {
          name: "超量标识",
          type: 'select',
          code: 'isChaoLiang',
          data: WhetherOptions
        },
        {
          name: "患者住院号或姓名",
          type: 'select',
          code: 'patientId',
          value:'parentId',
          filterMethod: this.getPatientDetailListNoDebounce1,
          data: [],
        },
          {
          name: "合并打印流水号",
          type: "input",
          code: "mergePrintNo",
        },
      ],
      returnInvoiceAmount: 0,
      returnInvoiceCode: '',
      isCopy: false,
      categorysNames: ''
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true
    }

    let params = this.$route.params
    if (params) {
      let supplierId = params.supplierId
      let supplierName = params.supplierName
      let billRegisterArray = params.billRegisterArray

      if (supplierId != 0) {
        this.form.supplierId = supplierId
        this.form.supplierName = supplierName
      }
      if (billRegisterArray && billRegisterArray.length > 0) {
        billRegisterArray.map(item => {
          this.form.details.push({
            billRegisterId: item.id,
            billRegisterNo: item.no,
            billNo: item.billNo,
            amount: item.totalAmount,
            paymentAmount: item.receivedAmount,
            unReceivedAmount: item.unReceivedAmount,
            number: item.unReceivedNumber
          })

          this.autoTotalAmount()
        })
      }
    }

    this.getSuppliers('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      this.form.categorys = this.selectValue.join(";")
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()

        this.form = res.returnData;
        if (this.form.details) {
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
        }
        var arr = this.form.categorys.split(";")
        this.selectValue = arr.map(Number) // 字符串转数字
        this.getCategorysName()
        this.initWorkFlowProperty(this.form);

        if (this.isCopy) {
          this.form.id = 0
          this.form.status = 2
          this.form.state = 0
          this.form.sourceId = id
          this.form.workFlowInstanceId = 0
          let now = this.parseTime(new Date())
          let user = this.userInfo
          this.form.createdUserName = user.name
          this.form.createdUser = user.id
          this.form.ownerDept = user.deptId
          this.form.ownerDeptName = user.deptName
          this.form.updateTime = now
          this.form.createdTime = res.returnData.createdTime
          this.form.selectType = res.returnData.selectType
          this.form.registerWay = 0

        }

        if (this.form.registerWay == 1) {
          this.editMode = false
          this.form.selectType = 1
        }
        // this.filterOptions
        this.filterOptions.push({
          name: "是否红冲",
          type: 'select',
          code: 'isRed',
          hidden: true,
          defaultValue: this.form.isRed
        })
        this.filterOptions.push({
          name: "发票登记",
          type: 'select',
          code: 'invoiceRegisterId',
          hidden: true,
          defaultValue: this.form.invoiceRegisterId
        })
        // this.$refs.selectDialog.getData();
      });
    },
   async validatePeriodStock(){
      if(this.form.selectType==1){
        return false
      }
      let isNext = false
      let inStockArr = this.form.details.filter(item => {
          if (item.purchaseInStockNo) {
            return item.purchaseInStockNo.slice(0, 4) === 'QCKC';
          }
          return false;
        });
        if(inStockArr.length>0){
          let ids = inStockArr.map(item => item.purchaseInStockId)
         await ValidatePeriodStockSupplier({ids}).then(res=>{
            isNext = !res.successful
          })
        }
        return isNext
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading', true);
      this.$refs["form"].validate((valid) => {

        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }

        if (this.form.details) {
          for (let i = 0; i < this.form.details.length; i++) {
            // if (this.form.isRed == 0) {
            //   if (!this.form.details[i].number || this.form.details[i].number < 0) {
            //     this.$my_message(`第${i + 1}行本次匹配数量必须大于0`, 'warning')
            //     return
            //   }
            // } else {
            //   if (!this.form.details[i].number || this.form.details[i].number > 0) {
            //     this.$my_message(`第${i + 1}行本次红冲匹配数量必须小于0`, 'warning')
            //     return
            //   }
            // }

            if (Math.abs(this.form.details[i].amount) > Math.abs(this.form.details[i].unRegisterAmount)) {
              this.$my_message(`第${i + 1}行本次匹配金额大于未匹配金额`, 'warning')
              this.$store.dispatch('SetLoading',false)
              return
            }
            // if (this.form.isRed == 1 && this.form.details[i].number > this.form.details[i].registerNumber) {
            //   this.$my_message(`第${i + 1}行红冲发票,本次红冲数量大于已登记数量`, 'warning')
            //   return
            // }
          }
        }
        if (this.form.invoiceAmount != this.form.totalAmount && (this.form.remark == null || this.form.remark == '')) {
          this.$my_confirm("发票金额不等于匹配金额，请在备注栏说明原因", "提示", {
            confirmButtonText: "我知道了",
            closeOnClickModal: false,
            showCancelButton: false,
            type: "warning",
          })
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        let _this = this
        this.validatePeriodStock().then(res=>{
         if(!res){
          if (_this.form.invoiceAmount != _this.form.totalAmount && (_this.form.remark != null && _this.form.remark != '')) {
            _this.$my_confirm("发票金额不等于匹配金额，请在备注栏说明原因，若已备注，是否继续验证通过？", "提示", {
            type: "warning",
          }).then(() => {
            _this.save();
          }).catch(()=>{
            _this.$store.dispatch('SetLoading',false)
          })
        }
        else {
          _this.save();
        }
         }
        })
     

        





        // if (this.form.isRed == 0) {
        //   if (this.form.invoiceAmount < this.form.totalAmount) {
        //     this.$my_message(`匹配金额不能小于发票金额`, "warning");
        //     return;
        //   }
        //   if (this.form.invoiceAmount > this.form.totalAmount && (this.form.remark == null || this.form.remark == '')) {
        //     this.$my_confirm("发票金额大于明细匹配合计金额，请在备注栏说明原因", "提示", {
        //       confirmButtonText: "我知道了",
        //       closeOnClickModal: false,
        //       showCancelButton: false,
        //       type: "warning",
        //     })

        //     return false;
        //   }

        //   if (this.form.invoiceAmount > this.form.totalAmount && (this.form.remark != null && this.form.remark != '')) {
        //     this.$my_confirm("发票金额大于明细匹配合计金额，请在备注栏说明原因,若已备注，是否继续验证通过？", "提示", {

        //       type: "warning",
        //     }).then(() => {
        //       this.save();
        //     })
        //   }
        //   else {
        //     this.save();
        //   }
        // } else {
        //   if (this.form.invoiceAmount > this.form.totalAmount) {
        //     this.$my_message(`匹配金额不能大于发票金额`, "warning");
        //     return;
        //   }
        //   if (this.form.invoiceAmount < this.form.totalAmount && (this.form.remark == null || this.form.remark == '')) {
        //     this.$my_confirm("发票金额小于明细匹配合计金额，请在备注栏说明原因", "提示", {
        //       confirmButtonText: "我知道了",
        //       closeOnClickModal: false,
        //       showCancelButton: false,
        //       type: "warning",
        //     })

        //     return false;
        //   }

        //   if (this.form.invoiceAmount < this.form.totalAmount && (this.form.remark != null && this.form.remark != '')) {
        //     console.log(this.form.remark, "this.form.remark12")
        //     this.$my_confirm("发票金额小于明细匹配合计金额，请在备注栏说明原因,若已备注，是否继续验证通过？", "提示", {

        //       type: "warning",
        //     }).then(() => {
        //       this.save();
        //     })
        //   }
        //   else {
        //     this.save();
        //   }
        // }

        // // 移至后端处理
        // if (this.form.isRed == 0) {
        //   this.form.state = 1 // 已验证
        // } else {
        //   this.form.state = 5 // 红字冲销
        // }
        // this.SaveDataAction(this.form).then((res) => {
        //   this.$my_message(`执行成功`, "success");
        //   sessionStorage.setItem("editMode", 0);
        //   // this.$router.push({ path: this.getMainPath(this.$route.path) });
        //   this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        // });
      });
    },
    save () {
      this.SaveDataAction(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        // this.$router.push({ path: this.getMainPath(this.$route.path) });
        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
      }).finally(() => {
        this.$store.dispatch('SetLoading',false)
        });;
    },
    resetForm () {

      this.selectValue = [0, 1, 2],
        this.form = {
          state: 0,
          supplierName: '',
          supplierId: '',
          type: 0,
          isRed: 0,
          // category: 0,
          categorys: [0, 1, 2],
          registerWay: 0,
          details: [],
          totalAmount: 0,
          totalNumber: 0,
          invoiceAmount: 0,
          createdTime: this.parseTime(new Date()),
          updateTime: this.parseTime(new Date()),
          createdUserName: this.userInfo.name,
          ownerDeptName: this.userInfo.deptName,
          date: this.parseTime(new Date(), "{y}-{m}-{d}"),
          selectType: 0,
          orgCode :sessionStorage.getItem('orgId')
        };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    goBack () {
      if (this.prevRoute.path == '/') {
        this.$router.go(-1)
      }
      else {
        this.routePushWithParams(this.prevRoute.path, this.$route.params);
      }
    },
    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
    // 明细表
    handleAddChildForm () {
      if (!this.form.supplierId) {
        this.$my_message(`需要先选择供应商`, 'warning')
        this.getSuppliers('')
        return;
      }
      // if (this.form.selectType !=0) {
      //   this.$my_message(`需要先选择按整单或按明细开票`, 'warning')
      //   return;
      // }
      this.returnInvoiceAmount = this.form.invoiceAmount
      this.returnInvoiceCode = this.form.billNo
      // if (!this.form.category ) {
      //   this.$my_message(`需要先选择业务类型`, 'warning')
      //   return;
      // }
      if (this.form.selectType == 1) {
        this.showSelectDialog = true;
      } else {
        this.showSelectDialogWholeOrder = true;
      }
      // 编辑时把已选数据赋值，待选✔
      if (this.form.details) {
        let details = JSON.parse(JSON.stringify(this.form.details))
        if (this.form.selectType == 1) {
          this.$nextTick(() => {
            this.$refs.selectDialog.rightChildSelectionDataReset(details)
          })
        } else {
          this.$nextTick(() => {
            this.$refs.selectDialogByWholeOrder.rightChildSelectionDataReset(details)
          })
        }

      }
      this.resetDetailFormData();
      this.supplierIdRest();
      this.selectDialogReset();

    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details == null ? 1 : this.form.details.length + 1,
        "amount": 0,
        "unReceivedAmount": 0,
        number: 0,
      };
    },
    getInvoiceRegisters (keyWord) {
      if (!this.form.supplierId) {
        this.$my_message(`需要先选择供应商`, 'warning')
        return;
      }
      GetInvoiceRegisters({ pageIndex: 1, pageSize: 100, keyWord: keyWord, states: [1, 2], supplierId: this.form.supplierId })
        .then(res => {
          this.invoices = res.returnData.data
        })
    },

    amountChange (row) {
      row.amount = (row.number * row.inStockPrice).toFixed(3) * 1;
      this.autoTotalAmount();
    },
    // autoAmount () {
    //   this.form.details.amount =
    //     ((this.form.details.number * 1) * this.form.details.inStockPrice).toFixed(3) * 1;

    // },
    autoTotalAmount () {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // totalAmount = totalAmount * 1 + element.inStockPrice * element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      console.log(this.form.details, "this.form.details");
      this.form.totalAmount = totalAmount.toFixed(3) * 1
      this.form.totalNumber = this.form.details ? this.form.details.length : 0
    },
    categoryChange (val) {
      this.form.details = []
      this.form.categorys = val.join(";")
      var item = this.filterOptions.find(e => e.code == "categorys")
      if (item) {
        item.defaultValue = val
      }
      else {
        this.filterOptions.push({
          name: "业务类型",
          type: 'select',
          code: 'categorys',
          hidden: true,
          defaultValue: val
        })
      }

      var item = this.filterOptionsByWholeOrder.find(e => e.code == "categorys")
      if (item) {
        item.defaultValue = val
      }
      else {
        this.filterOptionsByWholeOrder.push({
          name: "业务类型",
          type: 'select',
          code: 'categorys',
          hidden: true,
          defaultValue: val
        })
      }

      this.selectDialogReset();
    },

    // change event 
    supplierChange (row) {

      // this.form = Object.assign(this.form, row, {
      this.form.supplierName = row.name
      this.form.supplierId = row.id
      // });

      // var arr = this.STATIC_Suppliers.filter(e => e.id == val)
      // this.form.supplierId = arr[0].id
      // this.form.supplierName = arr[0].name

      this.form.details = []
      this.supplierIdRest();

      if (this.form.selectType == 0) {
        this.$refs.selectDialog.clear()
      } else {
        this.$refs.selectDialogByWholeOrder.clear()
      }
    },

    supplierIdRest () {

      var item = this.filterOptions.find(e => e.code == "supplierId")
      if (item) {
        item.defaultValue = this.form.supplierId
      }
      else {
        this.filterOptions.push({
          name: "供应商",
          type: 'select',
          code: 'supplierId',
          hidden: true,
          defaultValue: this.form.supplierId
        })
      }

      var item = this.filterOptionsByWholeOrder.find(e => e.code == "supplierId")
      if (item) {
        item.defaultValue = this.form.supplierId
      }
      else {
        this.filterOptionsByWholeOrder.push({
          name: "供应商",
          type: 'select',
          code: 'supplierId',
          hidden: true,
          defaultValue: this.form.supplierId
        })
      }
      this.selectDialogReset();
      this.getInvoiceRegisters();
    },
    // invoiceAmountChange (val) {
    //   if (this.form.invoiceAmount < 0) {
    //     this.form.isRed = 1;
    //   } else {
    //     this.form.isRed = 0;
    //   }
    //   this.isRedChangeRest();
    // },
    isRedChange (val) {
      this.form.details = []

      var item = this.filterOptions.find(e => e.code == "isRed")
      if (item) {
        item.defaultValue = this.form.isRed
      }
      else {
        this.filterOptions.push({
          name: "是否红冲",
          type: 'select',
          code: 'isRed',
          hidden: true,
          defaultValue: this.form.isRed
        })
      }
      if (this.form.isRed == 0) {
        this.selectDialogReset();
        this.form.invoiceRegisterId = ''
        this.form.oldBillCode = ''
      }
      var item = this.filterOptions.find(e => e.code == "invoiceRegisterId")
      if (item) {
        item.defaultValue = ''
        console.log(item, "item ");
      }

      this.getInvoiceRegisters(); // '', '', [1, 2, 5]
      this.selectDialogReset();

    },
    invoiceRegisterChange (val) {
      var arr = this.invoices.filter(e => e.id == val) //STATIC_InvoiceRegisters
      this.form.invoiceRegisterId = arr[0].id
      this.form.oldBillCode = arr[0].billNo

      this.form.details = []
      var item = this.filterOptions.find(e => e.code == "invoiceRegisterId")
      if (item) {
        item.defaultValue = this.form.invoiceRegisterId
      }
      else {
        this.filterOptions.push({
          name: "发票登记",
          type: 'select',
          code: 'invoiceRegisterId',
          hidden: true,
          defaultValue: this.form.invoiceRegisterId
        })
      }

      var item = this.filterOptionsByWholeOrder.find(e => e.code == "invoiceRegisterId")
      if (item) {
        item.defaultValue = this.form.invoiceRegisterId
      }
      else {
        this.filterOptionsByWholeOrder.push({
          name: "发票登记",
          type: 'select',
          code: 'invoiceRegisterId',
          hidden: true,
          defaultValue: this.form.invoiceRegisterId
        })
      }


      this.selectDialogReset();
    },
    restDetails () {
      this.form.details = []
    },
    selectDialogReset () {
      if (this.form.selectType == 1) {
        this.$refs.selectDialog.reset()
      } else {
        this.$refs.selectDialogByWholeOrder.reset()
      }
    },
    closeSelectDialog () {
      this.showSelectDialog = false
    },
    closeSelectDialogWholeOrder () {
      this.showSelectDialogWholeOrder = false
    },

    getSelectDialogData (data) {

      if (data) {
        this.form.details = []
        data.map(e => {
          e.number = e.thisUnRegisterNumber
          e.amount = (e.thisUnRegisterNumber * e.inStockPrice).toFixed(3) * 1
          e.unRegisterNumber = e.unRegisterNumber - e.thisUnRegisterNumber
          this.form.details.push(e)
        })
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      }
      this.autoTotalAmount();
      console.log(data, this.form.details, "getSelectDialogData")
    },
    getSelectDialogDataWholeOrder (data) {
      if (data) {
        this.form.details = []
        data.map(e => {
          this.form.details.push(e)
        })
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      }
      this.autoTotalAmount();
    },
    child1fomtter (row) {
      let no = row.drmDistributionNo ? row.drmDistributionNo : ''
      let date = row.drmDistributionDate ? this.parseTime(new Date(row.drmDistributionDate), "{y}-{m}-{d}") : ''
      return `${no}<br/>${date}`
    },
    child2fomtter (row) {
      let no = row.purchaseInStockNo ? row.purchaseInStockNo : ''
      let date = row.purchaseInStockDate ? this.parseTime(new Date(row.purchaseInStockDate), "{y}-{m}-{d}") : ''
      return `${no}<br/>${date}`
    },
    child3fomtter (row) {
      return `${row.productName}<br/>${row.registCertNo}`
    },
    child4fomtter (row) {
      let batch = row.batch ? row.batch : ''
      let date = row.validityDate ? this.parseTime(new Date(row.validityDate), "{y}-{m}-{d}") : ''
      return `${batch}<br/>${date}`
    },
    child5fomtter (row) {
      return `${row.price}<br/>${row.inStockNumber}`
    },
    child6fomtter (row) {
      return `${row.inStockAmount}<br/>${row.unRegisterAmount}`
    },
    child7fomtter (row) {
      return row.isChaoLiang === 1 ? "是" : row.isChaoLiang === 0? "否":'';
    },
    drmformatter (row) {
      let drmDistributionNo = row.drmDistributionNo ? row.drmDistributionNo : ''
      let date = row.drmDistributionDate ? this.parseTime(new Date(row.drmDistributionDate), "{y}-{m}-{d}") : ''
      return `${drmDistributionNo}<br/>${date}`
    },
    fomtter (row) {
      let date = row.purchaseInStockDate ? this.parseTime(new Date(row.purchaseInStockDate), "{y}-{m}-{d}") : ''
      return `${date}`
    },
    submitShowBtn () {
      // 展示: 未验证的 或者是新增时候  未通过的
      // 不展示：进行中的 ,查看详情 
      if (this.formMode == 3 || this.formMode == 0) {
        return false;
      }
      if (this.form.state == 0 || this.formMode == 1 || this.form.status == 0) {
        return true;

      }
      return false;
    },
    getCategorysName () {
      
      this.$nextTick(()=>{
        let names = this.selectValue.map(e => this.StockCategoryOptions.find(item => item.id === e)?.name).filter(e => e)
        this.categorysNames =  names.join('、')        
      })
   
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

/deep/.el-upload-list {
  float: right !important;
}
</style>
